const initialState = {
    dashboard: { totalUsers: 0, recentUsers: [] },
    users: [],
    logs: [],
    billingPlans: [],
    visitorInfo: [],
    states: [],
    records: [],
    organisations: [],
    customerSupport: [],
    versionPayments: [],
    financialYears: [],
    isLoggedIn: false,
    adminData: null
};

const superAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_ADMIN_DASHBOARD': return { ...state, dashboard: action.payload };
        case 'SET_ADMIN_USERS': return { ...state, users: action.payload };
        case 'SET_ADMIN_LOGS': return { ...state, logs: action.payload };
        case 'SET_ADMIN_BILLING_PLANS': return { ...state, billingPlans: action.payload };
        case 'SET_ADMIN_VISITOR_INFO': return { ...state, visitorInfo: action.payload };
        case 'SET_ADMIN_STATES': return { ...state, states: action.payload };
        case 'SET_ADMIN_RECORDS': return { ...state, records: action.payload };
        case 'SET_ADMIN_ORGANISATIONS': return { ...state, organisations: action.payload };
        case 'SET_ADMIN_CUSTOMER_SUPPORT': return { ...state, customerSupport: action.payload };
        case 'SET_ADMIN_VERSION_PAYMENTS': return { ...state, versionPayments: action.payload };
        case 'SET_ADMIN_FINANCIAL_YEARS': return { ...state, financialYears: action.payload };
        case 'SET_ADMIN_LOGIN': return { ...state, isLoggedIn: true, adminData: action.payload };
        default: return state;
    }
};

export default superAdminReducer;
